(function () {
  'use strict';

  var STORAGE_KEY = 'emd_machine_selection';

  function readSelection() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setState(root, state) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-compat-state]'), function (el) {
      el.hidden = el.dataset.compatState !== state;
    });
  }

  function matches(brandsAttr, selection) {
    if (!selection) return null;
    var brands = brandsAttr ? brandsAttr.split('||') : [];
    return brands.indexOf(selection.brand) !== -1;
  }

  function evaluateBadge(root, selection) {
    var isUniversal = root.dataset.universal === 'true';
    if (isUniversal) {
      setState(root, 'universal');
      return true;
    }
    if (!selection) {
      setState(root, 'empty');
      return null;
    }
    var isMatch = matches(root.dataset.brands, selection);
    if (isMatch) {
      var textEl = root.querySelector('[data-compat-match-text]');
      if (textEl) {
        textEl.textContent = (root.dataset.matchTemplate || '').replace('{{ brand }}', selection.brand);
      }
      setState(root, 'match');
    } else {
      var link = root.querySelector('[data-compat-mismatch-link]');
      if (link) {
        link.href = '/search?q=' + encodeURIComponent(selection.brand);
      }
      setState(root, 'mismatch');
    }
    return isMatch;
  }

  function evaluateAllBadges() {
    var selection = readSelection();
    Array.prototype.forEach.call(document.querySelectorAll('[data-compat-badge]'), function (root) {
      evaluateBadge(root, selection);
    });
    return selection;
  }

  function initFilterBar(bar) {
    var selectionEl = bar.querySelector('[data-compat-filter-selection]');
    var emptyEl = bar.querySelector('[data-compat-filter-empty]');
    var toggleWrap = bar.querySelector('[data-compat-filter-toggle-wrap]');
    var toggle = bar.querySelector('[data-compat-filter-toggle]');
    var labelEl = bar.querySelector('[data-compat-filter-label]');

    function applyFilter() {
      var selection = readSelection();
      var active = !!(toggle && toggle.checked && selection);
      Array.prototype.forEach.call(document.querySelectorAll('.product-card'), function (card) {
        if (!active) {
          card.hidden = false;
          return;
        }
        var badge = card.querySelector('[data-compat-badge]');
        if (!badge) {
          card.hidden = false;
          return;
        }
        if (badge.dataset.universal === 'true') {
          card.hidden = false;
          return;
        }
        var isMatch = matches(badge.dataset.brands, selection);
        card.hidden = !isMatch;
      });
    }

    function render() {
      var selection = readSelection();
      if (selection && selection.label) {
        if (selectionEl) {
          selectionEl.hidden = false;
          if (labelEl) labelEl.textContent = selection.label;
        }
        if (emptyEl) emptyEl.hidden = true;
        if (toggleWrap) toggleWrap.hidden = false;
      } else {
        if (selectionEl) selectionEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (toggleWrap) toggleWrap.hidden = true;
        if (toggle) toggle.checked = false;
      }
      applyFilter();
    }

    if (toggle) toggle.addEventListener('change', applyFilter);
    document.addEventListener('emd:machine:change', render);
    render();
  }

  function init() {
    evaluateAllBadges();
    Array.prototype.forEach.call(document.querySelectorAll('[data-compat-filter-bar]'), initFilterBar);
  }

  document.addEventListener('emd:machine:change', evaluateAllBadges);
  init();
})();
